import { FC, useContext } from 'react';
import styled from 'styled-components';
import { Icon } from '@stax-core/truffle-components';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { RoutesStore } from '../../context';
import { history } from '../../history';

export type BackButtonProps = Omit<FontAwesomeIconProps, 'icon'> &
  React.RefAttributes<HTMLSpanElement> & {
    /** This serves as the 'id', 'data-testid', and 'trackingId' */
    id: string;
    /**
     * Override path of the page to go to when the button is clicked, if not provided
     * the default of 'useContext(RoutesStore).previousRoute.path' is used
     */
    page?: string | null;
  };

// IMPORTANT: icons other than the ones specified in truffle's setupIcons.ts file
// will not work until loaded into the font-awesome library
library.add(faArrowLeft);

const BackButtonBar = styled.div`
  height: 24px;
  width: 24px;
  font-size: 1.35rem;
  cursor: pointer;

  & .fa-arrow-left {
    color: #009bf2;
  }
`;

export const BackButton: FC<BackButtonProps> = props => {
  const { previousRoute } = useContext(RoutesStore);
  const prevPath = props.page ?? previousRoute?.path;

  return !prevPath ? (
    <div></div>
  ) : (
    <BackButtonBar>
      <Icon
        icon={['fas', 'arrow-left']}
        data-testid={props.id}
        {...props}
        onClick={evt => {
          if (props.onClick) {
            props.onClick(evt);
            if (evt.defaultPrevented) {
              return;
            }
          }
          history.push(prevPath);
        }}
      />
    </BackButtonBar>
  );
};
